export default __webpack_public_path__ + "static/media/CarImages.PRunnerSmall.811ca70f.jpg";